import { theme } from "esa-components";
import { CSSProperties } from "react";

declare module "@mui/material/styles" {
  interface TypeBackground {
    grey: CSSProperties["color"];
  }
}

export default theme;
